import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="terms-container">
      <div className="terms-card">
        <h1 className="terms-title">Privacy Policy</h1>
        <p className="terms-updated">Last updated: October 9, 2025</p>

        <div className="terms-content">
          <p>
            This privacy policy applies to the <b> Mahaas app </b>(hereby
            referred to as "Application") for mobile devices that was created by
            Mahaas (hereby referred to as "Service Provider") as a Free service.
            This service is intended for use "AS IS".
          </p>

          <p>
            Information Collection and Use The Application collects information
            when you download and use it. This information may include
            information such as
          </p>

          <p>
            Your device's Internet Protocol address (e.g. IP address) The pages
            of the Application that you visit, the time and date of your visit,
            the time spent on those pages The time spent on the Application The
            operating system you use on your mobile device
          </p>

          <p>
            The Application collects your device's location, which helps the
            Service Provider determine your approximate geographical location
            and make use of in below ways:
          </p>

          <p>
            Geolocation Services: The Service Provider utilizes location data to
            provide features such as personalized content, relevant
            recommendations, and location-based services. Analytics and
            Improvements: Aggregated and anonymized location data helps the
            Service Provider to analyze user behavior, identify trends, and
            improve the overall performance and functionality of the
            Application. Third-Party Services: Periodically, the Service
            Provider may transmit anonymized location data to external services.
            These services assist them in enhancing the Application and
            optimizing their offerings.
          </p>
          <p>
            The Service Provider may use the information you provided to contact
            you from time to time to provide you with important information,
            required notices and marketing promotions.
          </p>

          <p>
            For a better experience, while using the Application, the Service
            Provider may require you to provide us with certain personally
            identifiable information. The information that the Service Provider
            request will be retained by them and used as described in this
            privacy policy.
          </p>

          <p>
            <b> Third Party Access </b> <br />
            Only aggregated, anonymized data is periodically transmitted to
            external services to aid the Service Provider in improving the
            Application and their service. The Service Provider may share your
            information with third parties in the ways that are described in
            this privacy statement.
          </p>
          <p>
            Please note that the Application utilizes third-party services that
            have their own Terms and Conditions. Below are the links to the
            Terms and Conditions of the third-party service providers used by
            the Application:
            <br />
            <b>Google Play Services </b> <br />
            <b>Google Analytics for Firebase </b> <br />
            <b>Firebase Crashlytics </b> <br />
          </p>

          <p>
            The Service Provider may disclose User Provided and Automatically
            Collected Information:
            <br />
            as required by law, such as to comply with a subpoena, or similar
            legal process; when they believe in good faith that disclosure is
            necessary to protect their rights, protect your safety or the safety
            of others, investigate fraud, or respond to a government request;
            with their trusted services providers who work on their behalf, do
            not have an independent use of the information we disclose to them,
            and have agreed to adhere to the rules set forth in this privacy
            statement.
          </p>

          <p>
            <b>Opt-Out Rights</b> <br />
            You can stop all collection of information by the Application easily
            by uninstalling it. You may use the standard uninstall processes as
            may be available as part of your mobile device or via the mobile
            application marketplace or network.
          </p>

          <p>
            <b>Data Retention Policy</b> <br />
            The Service Provider will retain User Provided data for as long as
            you use the Application and for a reasonable time thereafter. If
            you'd like them to delete User Provided Data that you have provided
            via the Application, please contact them at mahaasdairy@gmail.com
            and they will respond in a reasonable time.
          </p>

          <p>
            <b> Children</b> <br />
            The Service Provider does not use the Application to knowingly
            solicit data from or market to children under the age of 3. <br />
            The Application is not intended for anyone under the age of 3. The
            Service Provider does not knowingly collect personally identifiable
            information from children under 3 years of age. If the Service
            Provider discovers that a child under 3 has provided personal
            information, it will be immediately deleted from our servers. If you
            are a parent or guardian and you become aware that your child has
            provided us with personal information, please contact the Service
            Provider at mahaasdairy@gmail.com
          </p>

          <p>
            <b>Security</b> <br />
            The Service Provider is concerned about safeguarding the
            confidentiality of your information. The Service Provider provides
            physical, electronic, and procedural safeguards to protect
            information the Service Provider processes and maintains.
          </p>

          <p>
            <b>Changes</b> <br />
            This Privacy Policy may be updated from time to time for any reason.
            The Service Provider will notify you of any changes to the Privacy
            Policy by updating this page with the new Privacy Policy. You are
            advised to consult this Privacy Policy regularly for any changes, as
            continued use is deemed approval of all changes.
          </p>
          <p>These terms and conditions are effective as of 2025-10-08</p>

          <p>
            <b>Your Consent</b> <br />
            By using the Application, you are consenting to the processing of
            your information as set forth in this Privacy Policy now and as
            amended by us.
          </p>

          <h2>
            <b>Contact Us</b>
          </h2>
          <p>
            If you have any questions or suggestions about the Terms and
            Conditions, please do not hesitate to contact the Service Provider
            at <b> mahaasdairy@gmail.com</b>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
